<template>
  <div id="privacy-policy" class="fill-height align-start">
    <v-row class="g-container" no-gutters>
      <v-col>
        <div class="p-content-text mx-auto mt-2">
          <h2 class="ma-0">{{ $route.meta.title }}</h2>
          <br />
          <i-privacy-policy-text />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import iPrivacyPolicyText from '@/modules/auth/components/PrivacyPolicyText.vue'

export default {
  components: {
    iPrivacyPolicyText
  },

  computed: {
    ...mapGetters('tenant', ['privacyPolicyEnabled'])
  },

  created() {
    if (!this.privacyPolicyEnabled) {
      this.$router.replace({ name: 'dashboard' })
    }
  }
}
</script>

<style lang="scss" scoped>
#privacy-policy {
  .p-content-text {
    max-width: 940px;
  }
}
</style>
